import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class DomHelperService
{
    //noinspection JSMethodCanBeStatic
    /**
     * @param {Element} element
     * @param {string|string[]} className
     * @returns {boolean}
     */
    public hasClass(element: Element, className: string | string[]): boolean {

        // We accept either a string or array of strings.
        // Normalize to array of strings.
        let classNames: string[] = [];
        if (typeof className === 'string') {
            // Make sure we have data to set.
            if (className.trim().length < 1) {
                return;
            }

            classNames = [className];
        } else {
            classNames = className;
        }

        // Make sure we have data to set.
        if (classNames.length < 1) {
            return;
        }

        // Make sure we have an element to modify.
        if (element === null) {
            return;
        }

        let hasClass: boolean = classNames.length > 0;

        // Add class(es)
        if (element.classList) {
            for (let i: number = 0; i < classNames.length; i++) {
                hasClass = hasClass && element.classList.contains(classNames[i]);
                if (!hasClass) {
                    break;
                }
            }
        } else {
            for (let i: number = 0; i < classNames.length; i++) {
                hasClass = hasClass && new RegExp('(^| )' + classNames[i] + '( |$)', 'gi').test(element.className);
                if (!hasClass) {
                    break;
                }
            }
        }

        return hasClass;
    }

    /**
     * @param {Element} element
     * @param {string|string[]} className
     */
    public addClass(element: Element, className: string | string[]): void {

        // We accept either a string or array of strings.
        // Normalize to array of strings.
        let classNames: string[] = [];
        if (typeof className === 'string') {
            // Make sure we have data to set.
            if (className.trim().length < 1) {
                return;
            }

            classNames = [className];
        } else {
            classNames = className;
        }

        // Make sure we have data to set.
        if (classNames.length < 1) {
            return;
        }

        // Make sure we have an element to modify.
        if (element === null) {
            return;
        }

        // Add class(es)
        if (element.classList) {
            classNames.forEach(function (c) {
                element.classList.add(c);
            });
        } else {
            element.className += ' ' + classNames.join(' ');
        }
    }

    /**
     * @param {Element} element
     * @param {string|string[]} className
     */
    public removeClass(element: Element, className: string | string[]): void {

        // We accept either a string or array of strings.
        // Normalize to array of strings.
        let classNames: string[] = [];
        if (typeof className === 'string') {
            // Make sure we have data to set.
            if (className.trim().length < 1) {
                return;
            }

            classNames = [className];
        } else {
            classNames = className;
        }

        // Make sure we have data to set.
        if (classNames.length < 1) {
            return;
        }

        // Make sure we have an element to modify.
        if (element === null) {
            return;
        }

        // Remove class(es)
        classNames.forEach(function (c) {
            if (element.classList) {
                element.classList.remove(c);
            } else {
                element.className = element.className.replace(new RegExp('(^|\\b)' + c + '(\\b|$)', 'gi'), ' ');
            }
        });
    }
}
